import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EntityStatus, IconType } from '@pt/pt-models';
import { DocResourceStatus } from 'it/primatoo/openapi/api/org/schemas/common/DocResourceStatus';

@Component({
  selector: 'pt-document-status',
  template: `
    <ng-container *ngIf='currentDocumentStatus'>
      <div [ngSwitch]='true'>
        <ng-container *ngSwitchCase='currentDocumentStatus === EntityStatus.DRAFT'>
          <span class='badge rounded-pill bg-warning text-dark'>
            {{"TOOLTIP.DRAFT" | translate}}
          </span>
        </ng-container>

        <ng-container *ngSwitchCase='currentDocumentStatus === EntityStatus.PUBLISHED'>
          <span class='badge rounded-pill bg-primary'>
            {{"TOOLTIP.PUBLISHED" | translate}}
          </span>
        </ng-container>
      </div>
    </ng-container>
  `
})
export class DocumentStatusComponent implements OnChanges {

  @Input() documentStatus?: DocResourceStatus;
  public EntityStatus = EntityStatus;

  public IconType = IconType;
  public currentDocumentStatus: EntityStatus;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes &&  changes.documentStatus) {
      this.currentDocumentStatus = changes.documentStatus.currentValue;
    }
  }

}
